@import (reference) '../../constants/spacing.module.less';

.bulk-reship-modal-content {
  height: 208px;
  display: flex;
  flex-flow: column nowrap;
  gap: @space-8;
}

.bullet-list {
  list-style: inside disc;
  margin-left: @space-8;
}

.bullet-list-item {
  display: list-item;
}
